import { Navigate } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext';
import { getDefaultPathForSession } from '../auth/redirects';
import { LoadingState } from './LoadingState';

export function CatchAllRedirect() {
  const { session, isAuthenticated, isLoading } = useAuth();

  if (isLoading) {
    return <LoadingState fullScreen />;
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return <Navigate to={getDefaultPathForSession(session)} replace />;
}
